module.exports = __webpack_public_path__ + "static/img/2_1_1.0e192a9c.jpg";